/* Cabentra — theme behaviour.
   Vanilla only. No framework, no build step beyond Shopify CLI. */

(function () {
  'use strict';

  var body = document.body;
  var announcer = document.getElementById('a11y-announce');
  var lastFocus = null;

  function trapTab(event, container) {
    if (event.key !== 'Tab' || !container) return;
    var focusable = Array.prototype.filter.call(
      container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function announce(message) {
    if (!announcer) return;
    announcer.textContent = '';
    window.setTimeout(function () {
      announcer.textContent = message;
    }, 60);
  }

  /* ---- Specification rail -------------------------------------------- */

  var rail = document.getElementById('specification-rail');

  function railIsOverlay() {
    return window.matchMedia('(max-width: 63.99em)').matches;
  }

  function openRail(options) {
    if (!rail) return;
    var opts = options || {};
    lastFocus = document.activeElement;
    body.setAttribute('data-rail', 'open');

    if (railIsOverlay()) {
      rail.setAttribute('role', 'dialog');
      rail.setAttribute('aria-modal', 'true');
    }

    var tab = document.querySelector('[data-rail-open]');
    if (tab) tab.setAttribute('aria-expanded', 'true');

    /* Only steal focus when the rail behaves as an overlay. On desktop it
       sits alongside the page, so moving focus would interrupt the person
       mid-task for no reason. */
    if (railIsOverlay() && opts.moveFocus !== false) {
      var close = rail.querySelector('[data-rail-close]');
      if (close) close.focus();
    }
  }

  function closeRail() {
    if (!rail) return;
    body.setAttribute('data-rail', 'closed');
    rail.removeAttribute('role');
    rail.removeAttribute('aria-modal');

    var tab = document.querySelector('[data-rail-open]');
    if (tab) tab.setAttribute('aria-expanded', 'false');

    if (lastFocus && document.contains(lastFocus)) {
      lastFocus.focus();
    } else if (tab) {
      tab.focus();
    }
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-rail-open]')) {
      openRail();
    }
    if (event.target.closest('[data-rail-close]')) {
      closeRail();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && body.getAttribute('data-rail') === 'open' && railIsOverlay()) {
      closeRail();
      return;
    }
    if (body.getAttribute('data-rail') === 'open' && railIsOverlay()) {
      trapTab(event, rail);
    }
  });

  /* ---- Cart -----------------------------------------------------------
     Mutations request the rail section in the payload so Shopify re-renders
     it server-side. Never rebuild the rail markup in JavaScript — the Liquid
     is the single source of truth for how a line item displays. */

  function refreshRail(sectionHtml) {
    if (!rail || !sectionHtml) return;

    var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var next = parsed.getElementById('specification-rail');
    if (next) rail.innerHTML = next.innerHTML;

    var nextTab = parsed.querySelector('[data-rail-tab-count]');
    if (next && nextTab) {
      document.querySelectorAll('[data-rail-tab-count]').forEach(function (el) {
        el.textContent = nextTab.textContent;
      });
    }
  }

  function cartRequest(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(
        Object.assign({ sections: 'specification-rail' }, payload)
      )
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed: ' + response.status);
      return response.json();
    });
  }

  function addToCart(items) {
    return cartRequest(window.Shopify.routes.root + 'cart/add.js', { items: items })
      .then(function (data) {
        refreshRail(data.sections && data.sections['specification-rail']);
        announce(document.documentElement.getAttribute('data-i18n-added') || 'Added to your specification.');
        if (body.getAttribute('data-rail-open-on-add') !== 'false') openRail({ moveFocus: false });
        return data;
      });
  }

  function changeLine(line, quantity) {
    return cartRequest(window.Shopify.routes.root + 'cart/change.js', {
      line: line,
      quantity: quantity
    }).then(function (data) {
      refreshRail(data.sections && data.sections['specification-rail']);
      announce(
        quantity === 0
          ? 'Item removed from your specification.'
          : 'Specification updated.'
      );
      return data;
    });
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-rail-remove]');
    if (remove) {
      var line = parseInt(remove.getAttribute('data-line'), 10);
      if (!isNaN(line)) {
        remove.disabled = true;
        changeLine(line, 0).catch(function (error) {
          console.error(error);
          announce('That item could not be removed. Try again.');
          remove.disabled = false;
        });
      }
    }

    if (event.target.closest('[data-rail-clear]')) {
      fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ sections: 'specification-rail' })
      })
        .then(function (r) { if (!r.ok) throw new Error('Clear failed'); return r.json(); })
        .then(function (data) {
          refreshRail(data.sections && data.sections['specification-rail']);
          announce('Specification cleared.');
        })
        .catch(function (error) {
          console.error(error);
          announce('The specification could not be cleared. Try again.');
        });
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-rail-qty]');
    if (!input) return;

    var line = parseInt(input.getAttribute('data-line'), 10);
    var quantity = parseInt(input.value, 10);
    if (isNaN(line) || isNaN(quantity) || quantity < 0) return;

    input.disabled = true;
    changeLine(line, quantity)
      .catch(function (error) {
        console.error(error);
        announce('That change could not be saved. Try again.');
      })
      .finally(function () {
        input.disabled = false;
      });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-add-to-spec]');
    if (!form) return;

    event.preventDefault();
    var formData = new FormData(form);
    var properties = {};
    var submit = form.querySelector('[type="submit"]');
    var error = form.querySelector('[data-product-form-error]');

    /* Disabling a focused button drops keyboard focus to <body>, which sends a
       keyboard or screen-reader user back to the top of the page after every
       add. Remember whether the button had focus and hand it back afterwards. */
    var submitHadFocus = submit && document.activeElement === submit;
    if (submit) {
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
    }
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }

    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    });

    addToCart([
      {
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity'), 10) || 1,
        properties: properties
      }
    ]).catch(function (requestError) {
      console.error(requestError);
      announce('That could not be added. Try again.');
      if (error) {
        error.textContent = 'That could not be added. Check the selected options and try again.';
        error.hidden = false;
      }
    }).finally(function () {
      if (submit) {
        submit.removeAttribute('aria-busy');
        if (form.querySelector('[data-variant-id]').value) submit.disabled = false;
        if (submitHadFocus && !submit.disabled && (document.activeElement === document.body || !document.activeElement)) submit.focus();
      }
    });
  });

  /* ---- Audience switch ------------------------------------------------
     Read once, exposed as a body attribute. Sections read the attribute;
     they never re-derive the audience themselves. */

  var prompt = document.querySelector('[data-audience-prompt]');
  if (prompt && document.cookie.indexOf('cabentra_audience=') === -1) {
    prompt.hidden = false;
  }

  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-audience-set]');
    if (!control) return;

    var audience = control.getAttribute('data-audience-set');
    body.setAttribute('data-audience', audience);
    document.dispatchEvent(new CustomEvent('cabentra:audience-change', { detail: { audience: audience } }));
    document.querySelectorAll('[data-audience-set]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-audience-set') === audience ? 'true' : 'false');
    });
    document.cookie = 'cabentra_audience=' + audience + ';path=/;max-age=31536000;SameSite=Lax';
    if (prompt) prompt.hidden = true;
    var chosen = control.textContent.trim();
    announce('Showing ' + chosen + ' pricing and products.');
  });


  /* ---- Header: search, mobile menu, dropdowns ------------------------- */

  var search = document.getElementById('site-search');
  var mmenu = document.getElementById('mobile-menu');
  if (mmenu) mmenu.hidden = true;

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-search-open]')) {
      if (!search) return;
      search.hidden = !search.hidden;
      var t = document.querySelector('[data-search-open]');
      if (t) t.setAttribute('aria-expanded', String(!search.hidden));
      if (!search.hidden) {
        var field = search.querySelector('input[type="search"]');
        if (field) field.focus();
      }
    }
    if (event.target.closest('[data-search-close]') && search) {
      search.hidden = true;
      var to = document.querySelector('[data-search-open]');
      if (to) { to.setAttribute('aria-expanded', 'false'); to.focus(); }
    }
    if (event.target.closest('[data-menu-open]') && mmenu) {
      mmenu.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var mo = document.querySelector('[data-menu-open]');
      if (mo) mo.setAttribute('aria-expanded', 'true');
      var first = mmenu.querySelector('a, button');
      if (first) first.focus();
    }
    if (event.target.closest('[data-menu-close]') && mmenu) {
      mmenu.hidden = true;
      document.documentElement.style.overflow = '';
      var mc = document.querySelector('[data-menu-open]');
      if (mc) { mc.setAttribute('aria-expanded', 'false'); mc.focus(); }
    }
    /* Close any open header dropdown when clicking elsewhere */
    document.querySelectorAll('[data-dd][open]').forEach(function (dd) {
      if (!dd.contains(event.target)) dd.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (event) {
    if (mmenu && !mmenu.hidden && event.key === 'Tab') {
      trapTab(event, mmenu);
      return;
    }
    if (event.key !== 'Escape') return;
    if (mmenu && !mmenu.hidden) {
      mmenu.hidden = true;
      document.documentElement.style.overflow = '';
      var m = document.querySelector('[data-menu-open]');
      if (m) { m.setAttribute('aria-expanded', 'false'); m.focus(); }
    } else if (search && !search.hidden) {
      search.hidden = true;
      var s = document.querySelector('[data-search-open]');
      if (s) { s.setAttribute('aria-expanded', 'false'); s.focus(); }
    }
    document.querySelectorAll('[data-dd][open]').forEach(function (dd) { dd.removeAttribute('open'); });
  });

  /* Hide the floating tab while the footer is on screen */
  var railTab = document.querySelector('.rail-tab');
  var footerEl = document.querySelector('.footer');
  if (railTab) body.setAttribute('data-rail-tab', 'shown');
  if (railTab && footerEl && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var atFooter = entries[0].isIntersecting;
      railTab.setAttribute('data-at-footer', atFooter ? 'true' : 'false');
      body.setAttribute('data-rail-footer', atFooter ? 'true' : 'false');
      document.body.setAttribute('data-rail-tab', atFooter ? 'hidden' : 'shown');
    }, { rootMargin: '0px 0px -10% 0px' }).observe(footerEl);
  }

  window.Cabentra = {

    openRail: openRail,
    closeRail: closeRail,
    addToCart: addToCart,
    changeLine: changeLine,
    announce: announce
  };
})();
